export function formatDateAndTime(dateString , addComma=true) {
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata"
  });

  let formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata"
  });

  formattedTime = formattedTime.replace("am", "AM").replace("pm", "PM");
  const finalData = addComma ? `${formattedDate}, ${formattedTime}` : `${formattedDate} ${formattedTime}`

  return finalData;
}
